import { render, staticRenderFns } from "./CreateContentChain.vue?vue&type=template&id=534719a4&"
import script from "./CreateContentChain.vue?vue&type=script&lang=js&"
export * from "./CreateContentChain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports